exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".profile-alert-copy{background-color:white;padding:8px;position:absolute;right:calc(50% - 147px);top:40px;z-index:100000;box-shadow:rgba(50,50,93,0.25) 0px 6px 12px -2px,rgba(0,0,0,0.3) 0px 3px 7px -3px}.profile-alert-copy-block{background:white;padding:10px;transform:rotate(45deg);position:absolute;top:-4px;left:70px;z-index:-1000}.change-password-button{margin-top:20px;margin-bottom:20px;display:flex;justify-content:center;width:100%;border:none;position:relative;padding:13px 0;background-color:#d8d8d8;font-weight:600}.change-password-button img{position:absolute;left:40px}.darkText{color:#525252}.infoIconDark{filter:brightness(0) invert(1)}.info-icon{margin-left:7px}.darkInput{background-color:#4a4a4a}.info-item{position:\"absolute\";top:40;right:'-35px';width:'170px';z-index:1001;font-size:11}.profile-input-date[type=\"date\"]::-webkit-calendar-picker-indicator{display:none}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/assets/css/_profile.scss
// module id = 1890
// module chunks = 7